'use strict';

/*global echo */
/*global isEmpty */

function MapLatLng(data) {
    //souradnice
    this.latitude        = !isEmpty(data) && data.hasOwnProperty('latitude')            ? data.latitude               : '';
    this.longitude       = !isEmpty(data) && data.hasOwnProperty('longitude')           ? data.longitude              : '';
    this.altitude        = !isEmpty(data) && data.hasOwnProperty('altitude')            ? data.altitude               : '';
    
    //odpovidajici polozka
    this.item            = !isEmpty(data) && data.hasOwnProperty('item')                ? data.item                   : '';
}
